import React, { useEffect } from 'react';
import { Route, Routes as RouterRoutes, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { loadAuthentication } from './actions';
import ForgotPasswordContainer from './components/ForgotPasswordContainer';
import LoginContainer from './components/LoginContainer';
import RegisterContainer from './components/RegisterContainer';
import ResetPasswordContainer from './components/ResetPasswordContainer';
var Routes = function Routes(_ref) {
  var foundUsOptions = _ref.foundUsOptions,
    init = _ref.init;
  useEffect(function () {
    init(foundUsOptions);
  }, []);
  var location = useLocation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterRoutes, null, location.pathname.includes('login') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    path: "reset-password/:hash/:userIdentity",
    element: /*#__PURE__*/React.createElement(ResetPasswordContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "forgot-password",
    element: /*#__PURE__*/React.createElement(ForgotPasswordContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":failure?/:message?",
    element: /*#__PURE__*/React.createElement(LoginContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(LoginContainer, null)
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    path: "confirm/:data",
    element: /*#__PURE__*/React.createElement(RegisterContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(RegisterContainer, null)
  }))));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var application = _ref2.application;
  return {
    foundUsOptions: application.config.foundUsOptions
  };
};
var mapDispatchToProps = {
  init: loadAuthentication
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);